import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractBoxFileListComponent } from '../../shared/abstract-box-files-list.component';

@Component({
    selector: 'app-operation-box-files-list',
    templateUrl: './operation-box-files-list.component.html',
    styleUrls: ['./operation-box-files-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OperationBoxFilesListComponent extends AbstractBoxFileListComponent {}
